import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react-components';
import {
  Collapse,
  useCollapseState,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';
import { andComp, entityIs, propertyIs } from '@bingads-webui-campaign-react/form-error';
import { Campaign } from '@bingads-webui/campaign-odata-schemas';
import { ValidationGroup } from '@bingads-webui-react/validation';
import { ValidatedFormCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';

import CampaignNameImg from '../media/campaign-name-icon.svg';

export const CampaignPanel = ({ campaign, onDataChange }) => {
  const i18n = useContext(I18nContext);

  const [
    campaignSection,
    campaignExpandedSection,
    setcampaignExpandedSection,
  ] = useCollapseState(['campaign'], ['campaign']);

  const campaignNameProp = andComp(entityIs(ERROR_ENTITY.Campaign), propertyIs('Name'));

  const onCampaignDataChange = useCallback((results) => {
    onDataChange({
      data: prevData => ({
        ...prevData,
        campaign: {
          ...prevData.campaign,
          ...results.data,
        },
      }),
      isValid: results.isValid,
      isDirty: results.isDirty,
    });
  }, [onDataChange]);

  return (
    <div className="campaign-section">
      <ValidationGroup
        validationProps={{
          schema: Campaign,
          onValidate: onCampaignDataChange,
          data: campaign,
          i18n,
          stopPropagation: true,
        }}
      >
        <Collapse
          allPanelItems={campaignSection}
          checkItems
          skipItemsTypeCheck
          activeKeys={campaignExpandedSection}
          setActiveKeys={setcampaignExpandedSection}
        >
          <ValidatedFormCard
            key="campaign"
            className="campaign-card"
            attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
          >
            <FormCardBasicHeader
              title={i18n.getString(_TL_('Campaign name'))}
              helpLabel={i18n.getString(_TL_('Click to learn more about campaign name'))}
              helpTopic="pop_BA_CampaignCreate_Settings_CampaignName"
              contentBefore={<Image src={CampaignNameImg} aria-hidden />}

            />
            <FormCardBody>
              <RemainingCharsValidatedTextField
                placeholder={i18n.getString(_TL_('Enter a name for your campaign'))}
                className="input-campaign-name"
                validationProps={{
                  field: 'Name',
                  schema: Campaign,
                }}
                i18n={i18n}
                formErrorProps={{ filter: campaignNameProp }}
              />
            </FormCardBody>
          </ValidatedFormCard>
        </Collapse>
      </ValidationGroup>
    </div>
  );
};

CampaignPanel.propTypes = {
  campaign: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
};
